/**
 * Created by yaseminturgay on 23.06.23.
 */
import { makeAutoObservable } from 'mobx';
import { HttpBackend } from '../../../Services/Http/HttpBackend';
import { PointsModelRule, createPointsModelRule } from './PointsModelRule';
import { PointsLimitStatus, createPointsLimitStatus } from './PointsLimitStatus';

type RewardsWalletType = {
  totalCollectedRewardCoins: number;
};

export type PointsModel = {
  collectedPoints: number;
  totalPossiblePointsToday: number;
  totalRewardsPoints: number;
  totalCollectedExperiencePoints: number;
  totalCollectedPoints: number;
  rewardsWallet: RewardsWalletType;
  dailyRules: PointsModelRule[];
  specialRules: PointsModelRule[];
  limitStatus?: PointsLimitStatus;
};

export function createPointsModel(json?: Partial<PointsModel>): PointsModel {
  return makeAutoObservable({
    collectedPoints: json?.collectedPoints ?? 0,
    totalPossiblePointsToday: json?.totalPossiblePointsToday ?? 0,
    totalRewardsPoints: json?.totalRewardsPoints ?? 0,
    totalCollectedExperiencePoints: json?.totalCollectedExperiencePoints ?? 0,
    totalCollectedPoints: json?.totalCollectedPoints ?? 0,
    rewardsWallet: json?.rewardsWallet ?? { totalCollectedRewardCoins: 0 },
    dailyRules: ((json?.dailyRules as any) ?? []).map((e: any) => createPointsModelRule(e)),
    specialRules: ((json?.specialRules as any) ?? []).map((e: any) => createPointsModelRule(e)),
    limitStatus: json?.limitStatus ? createPointsLimitStatus(json.limitStatus as any) : undefined,
  });
}

export const PointsModelApi = {
  overview(): Promise<PointsModel> {
    return HttpBackend.get('/coach-program/engagement/rewards/overview').then((res) => createPointsModel(res));
  },
};
